import { createTheme } from '@mui/material/styles';
import spinwerad from './assets/fonts/spinwerad.ttf';
import config from './config';

export const myColors = config.colors;

// A custom theme for this app
const theme = createTheme({
  cssVariables: true,
  palette: {
    primary: {
      main: myColors.primary,
      contrastText: myColors.primary,
    },
    secondary: {
      main: myColors.secondary,
      light: myColors.secondaryBackground,
      contrastText: myColors.secondaryContrastText,
    },
    text: {
      primary: myColors.primary,
    },
    background: {
      default: myColors.background,

    },
  },
  typography: {
    fontFamily: 'Montserrat, spinwerad',
    fontWeightLight: 300,
    fontSize: 16,
  },
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          opacity: 0.3  ,
          '&:hover': {
            opacity: 1,
          },
        }),
      },
    },
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          // no background
          backgroundColor: 'transparent', 
          opacity: 0.7,
          '&:hover': {
            opacity: 1  ,
          },
        }),
      },
    },
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'spinwerad';
          font-style: normal;
          font-display: swap;
          font-weight: 500;
          src: local('spinwerad'), local('spinwerad'), url(${spinwerad}) format('truetype');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
    },
  },
});

export default theme;
